import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AdminOverview() {
    const [counts, setCounts] = useState({ news: 0, events: 0, board: 0, directory: 0, messages: 0 });

    useEffect(() => {
        (async () => {
            try {
                const [news, events, board, directory, messages] = await Promise.all([
                    api.get("/admin/news"),
                    api.get("/admin/events"),
                    api.get("/admin/board"),
                    api.get("/admin/directory"),
                    api.get("/admin/messages"),
                ]);
                setCounts({
                    news: news.data.length,
                    events: events.data.length,
                    board: board.data.length,
                    directory: directory.data.length,
                    messages: messages.data.length,
                });
            } catch (e) {
                console.error(e);
            }
        })();
    }, []);

    const cards = [
        { label: "Noticias", value: counts.news, key: "news" },
        { label: "Eventos", value: counts.events, key: "events" },
        { label: "Junta directiva", value: counts.board, key: "board" },
        { label: "Socios directorio", value: counts.directory, key: "directory" },
        { label: "Mensajes recibidos", value: counts.messages, key: "messages" },
    ];

    return (
        <div data-testid="admin-overview">
            <div className="text-xs uppercase tracking-widest text-[#082050]/70">Panel</div>
            <h1 className="mt-2 text-3xl font-semibold text-[#082050] tracking-tight">Resumen</h1>
            <p className="mt-2 text-[#4A5568]">Gestiona el contenido del sitio ASATTA.</p>

            <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-4">
                {cards.map((c) => (
                    <div
                        key={c.key}
                        data-testid={`stat-${c.key}`}
                        className="bg-white border border-[#E2E4E9] p-6"
                    >
                        <div className="text-xs uppercase tracking-widest text-[#082050]/60">{c.label}</div>
                        <div className="mt-2 text-4xl font-semibold text-[#082050]">{c.value}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
